export { default } from "./CardLimits";



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/CardLimits/index.js